type SearchUpsellType = 'advanced_search' | 'paper_finder';
type SearchUpsellSurface = 'search_inline' | 'search_modal';

const ENTITY_IDS = {
  advanced_search: { search_inline: 1, search_modal: 2 },
  paper_finder: { search_inline: 3, search_modal: 4 },
};

export function getSearchUpsellTracking(
  upsellType: SearchUpsellType,
  sourceSurface: SearchUpsellSurface,
  trigger: string,
): { source: string; entity_id: number; extra: Record<string, string> } {
  return {
    source: 'search_upsell',
    entity_id: ENTITY_IDS[upsellType][sourceSurface],
    extra: { upsell_type: upsellType, source_surface: sourceSurface, trigger },
  };
}
